export const ASSIGNMENT_TYPES = {
  SA_TYPE_ROUND_ROBIN_ALL: 'round_robin_all',
  SA_TYPE_ROUND_ROBIN_ROLE: 'round_robin_role',
  SA_TYPE_ROUND_ROBIN_TEAM_MEMBERS: 'round_robin_team_members',
  SA_TYPE_TEAM_MEMBER: 'team_member',
  SA_TYPE_TEAM_MEMBER_FIELD: 'team_selector_field',
  SA_TYPE_LAST_ACTIVE_TEAM_MEMBER: 'last_active',
  SA_TYPE_LAST_ACTIVE_TEAM_MEMBER_SPEC_ROLE: 'last_active_role',
  SA_TYPE_SPEC_ROLE: 'specific_role',
  SA_TYPE_TEAM_MEMBER_FROM_VARIABLE: 'team_member_from_variable',
  SA_TYPE_OWNER: 'owner',
  SA_TYPE_ROLE_FROM_VARIABLE: 'role_from_variable',
} as const;

export const ASSOCIATION_SOURCES = {
  NONE: 'none',
  CONTEXT_RECORD: 'context_record',
  RELATED_FIELD: 'related_field',
  RECORD_VARIABLE: 'record_variable',
  VARIABLE_RELATED_FIELD: 'variable_related_field',
} as const;

export const SCHEDULE_TYPES = {
  IMMEDIATELY: 'immediately',
  WITH_DELAY: 'with_delay',
  ON_OR_AROUND_DATE: 'on_or_around_date',
  ON_OR_AROUND_DATE_VARIABLE: 'on_or_around_date_variable',
} as const;

export const TIMEOFFSET_VALUE_MIN = 1;
export const TIMEOFFSET_VALUE_MAX = 60;
export const DELAYCHANGE_VALUE_MIN = 1;
export const DELAYCHANGE_VALUE_MAX = 180;
export const DATEOFFSET_VALUE_MIN = 1;
export const DATEOFFSET_VALUE_MAX = 365;

export const VARIABLE_FIELD_RESOLUTIONS = {
  OVERWRITE: 'overwrite',
  UPDATE_IF_BLANK: 'update_if_blank',
} as const;
